<template>
  <mc-notification
    class="notification-banner"
    fit="large"
    verticalalign="middle"
    :body="text"
    appearance="info"
    actionsposition="right"
    data-test="notification-banner"
  >
    <mc-modal
      :open="showModal"
      dimension="medium"
      fit="medium"
      :heading="$t('manageBookings.modalTitle')"
      height="fit-content"
      @closed="showModal = false"
    >
      <p v-html="$t('manageBookings.modalContent')"></p>

      <mc-button
        slot="primaryAction"
        appearance="primary"
        fit="medium"
        dialogaction="ok"
        :href="buttonLink"
        @click="handleBannerAction(false, 'Modal_Button')"
      >
        {{ $t("manageBookings.textButton") }}
      </mc-button>
      <mc-button
        slot="secondaryAction"
        appearance="neutral"
        variant="filled"
        dialogaction="cancel"
        fit="medium"
        @click="handleBannerAction(false, 'Modal_Close')"
        >{{ $t("common.close") }}</mc-button
      ></mc-modal
    >

    <span slot="icon"><img class="notification-banner__image mr-3" src="@/assets/mb_banner.svg" alt="" /></span>

    <span>
      <p>{{ $t("manageBookings.text") }}</p>
      <p class="mds-text--small-normal">
        {{ $t("manageBookings.text2") }}
        <button
          type="button"
          class="notification-banner__more"
          @click="handleBannerAction(true, 'More_Button')"
          @keyup.enter="showModal = true"
        >
          + {{ $t("common.more") }}
        </button>
      </p></span
    >
    <span v-if="showButton" slot="actions">
      <mc-button
        :label="buttonText"
        appearance="primary"
        :trailingicon="buttonIcon ? 'square-arrow-up-right' : ''"
        :target="buttonLinkNewWindow ? '_blank' : ''"
        data-test="notification-banner-button"
        :href="buttonLink"
        @click="$emit('notificationTracking')"
      />
    </span>
  </mc-notification>
</template>

<script>
import "@maersk-global/mds-components-core/mc-button";
export default {
  name: "NotificationBanner",
  props: {
    text: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonIcon: {
      type: Boolean,
      default: false
    },
    buttonLink: {
      type: String,
      default: ""
    },
    buttonLinkNewWindow: {
      type: Boolean,
      default: false
    }
  },
  emits: ["notificationTracking"],
  data() {
    return { showModal: false };
  },
  computed: {
    showButton() {
      return Boolean(this.buttonText && this.buttonLink);
    }
  },
  methods: {
    handleBannerAction(showModal, labelData) {
      this.showModal = showModal;
      globalThis.dataLayer.push({
        category: "Component",
        event: "DQCS",
        action: "Click",
        label: { data: "C1V_BetaBanner_" + labelData }
      });
    }
  }
};
</script>
